// Where the staff dashboard lives. Random so it can't be guessed or stumbled on; the old /admin now shows the home page rather
// than pointing here. This only hides the page: what keeps it safe is the database refusing anyone who isn't staff.
// The server's emails to staff link here too (netlify/lib/homes/roomEmails.mjs, netlify/functions/maintain-housing-enquiries.mjs).
export const ADMIN_PATH = '/team-oq3hp5tyadye1xsr';
